import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import Typography from './common/Typography';

import pagenavigation_arrow_left from '../asset/img/pagenavigation_arrow_left.svg';
import pagenavigation_arrow_right from '../asset/img/pagenavigation_arrow_right.svg';
import pagenavigation_chat_icon from '../asset/img/pagenavigation_chat_icon.svg';
import pagenation_home_icon from '../asset/img/pagenation_home_icon.svg';
import { checkHouseNextFunction } from '../common/Util';

const PageNavigationStyled = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  display: flex;
  height: 70px;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid var(--GrayScale-400);
  background: var(--GrayScale-0);

  .displayFlexColumn {
    align-items: center;
  }

  .arrowBox {
    width: 24px;
    height: 24px;
    padding: 3px 6px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .chat_icon {
    width: 50px;
    height: 50px;
    padding: 15px;
    justify-content: center;
    align-items: center;
    display: flex;
    border-radius: 51px;
    background: var(--Primary-500);
  }
`;

const PageNavigation = ({ prevPath, nextPath }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation('common');
  const [isResult, setIsResult] = useState(false);
  const [isPrevious, setIsPrevious] = useState(false);
  const { isMagam, isCertify } = useSelector(state => state.common);

  useEffect(() => {
    setIsResult(pathname.includes('result'));
    setIsPrevious(pathname.includes('previousEmployment'));
  }, [pathname]);

  const nextButtonHandler = () => {
    // 체크할 경로 리스트
    const pathList = ['deductions', 'evidenceDocuments', 'resultQuery'];

    // pathList의 요소 중 하나라도 현재 pathname에 포함되어 있는지 확인
    const isIncludedPath = pathList.some(path => nextPath.includes(path));

    if (isIncludedPath) {
      checkHouseNextFunction(dispatch, t, navigate, nextPath, isMagam, isCertify);
    } else {
      navigate(nextPath);
    }
  };

  const chatOpenHandler = () => {
    navigate('/aiAsst');
  };

  return (
    <PageNavigationStyled>
      <div className="displayFlexColumn">
        <div className="arrowBox" onClick={() => navigate(prevPath)}>
          <img
            src={isPrevious ? pagenation_home_icon : pagenavigation_arrow_left}
            alt={isPrevious ? '홈으로' : '이전으로'}
          />
        </div>
        <Typography variant="captionMedium">
          {isPrevious ? t('pageNavigation.home') : t('pageNavigation.previous')}
        </Typography>
      </div>
      <div className="chat_icon">
        <img src={pagenavigation_chat_icon} alt="채팅상담연결" onClick={chatOpenHandler} />
      </div>
      <div className="displayFlexColumn">
        <div className="arrowBox" onClick={nextButtonHandler}>
          <img
            src={isResult ? pagenation_home_icon : pagenavigation_arrow_right}
            alt={isResult ? '홈으로' : '다음으로'}
          />
        </div>
        <Typography variant="captionMedium">
          {isResult ? t('pageNavigation.home') : t('pageNavigation.next')}
        </Typography>
      </div>
    </PageNavigationStyled>
  );
};

export default PageNavigation;
